import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { ArrowLeft } from "lucide-react";

export default function About() {
  const navigate = useNavigate();
  return (
    <div className="max-w-xl mx-auto space-y-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" onClick={()=>navigate("/ajustes")} className="h-9 px-2"><ArrowLeft size={18} /></Button>
        <h1 className="font-heading text-2xl font-semibold">Acerca de</h1>
      </div>
      <Card>
        <CardContent className="p-5 space-y-3 text-sm">
          <div className="flex items-center gap-3">
            <Logo variant="mark" className="h-12 w-12" />
            <div>
              <div className="font-heading text-base font-semibold">
                <span>Cuenta</span><span className="text-[hsl(var(--primary))]"> Vaca</span>
              </div>
              <div className="text-muted-foreground text-xs uppercase tracking-[0.1em] font-mono">Inventario · Identifica · Controla</div>
            </div>
          </div>
          <div className="text-muted-foreground">Versión 1.0.0 — PWA + Capacitor (iOS/Android).</div>
          <div className="text-muted-foreground">Funciona 100% offline con sincronización automática al volver la conexión.</div>
          <div className="text-muted-foreground">Lector RFID físico (HID) y carga manual.</div>
          <div className="text-muted-foreground">Desarrollado para Rimoly South INC · Elio Rivas.</div>
        </CardContent>
      </Card>
    </div>
  );
}
